





































































































































































import { defineComponent } from "@vue/composition-api";
import { Calculation, filterCalculations } from "@/models/Calculation";
import { Federation } from "@/models/Federation";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { Actions, Getters, Mutations } from "@/store/index";
import { CalculationListViewData, Sort } from "@/types";
import { sortBy } from "lodash";
const calculationTypes = ["Contingent", "ServiceFee"];
import {
  Container,
  TextField,
  TableSortHeader,
  CreateCalculationDialog,
  LoadingSpinner,
  Checkbox,
} from "@/components";
import LayoutDefault from "@/layouts/LayoutDefault.vue";

const calculationTypesItems = [
  {
    key: "Contingent",
    display: "Kontingent",
  },
  {
    key: "ServiceFee",
    display: "Serviceavgift",
  },
];

const membershipTypeItems = [
  {
    key: 0,
    display: "Ordinært",
  },
  {
    key: 1,
    display: "Fagmedlemskap",
  },
  {
    key: 2,
    display: "Ekstraordinært",
  },
];

const sortByKey = (calculations: Calculation[], sort: Sort) => {
  let toSortingTypes = calculations.map((calc) => ({
    ...calc,
    nhoNumber: calc.nhoNumber,
  }));
  let sortedArr = sortBy(toSortingTypes, sort.key);
  let toCalculationTypes = sortedArr.map((calc) => ({
    ...calc,
    nhoNumber: calc.nhoNumber,
  }));

  return sort.direction === "asc"
    ? toCalculationTypes.reverse()
    : toCalculationTypes;
};

export default defineComponent({
  name: "CalculationList",
  components: {
    TableSortHeader,
    CreateCalculationDialog,
    LoadingSpinner,
    Container,
    TextField,
    Checkbox,
    LayoutDefault,
  },
  data(): CalculationListViewData {
    return {
      createCalcDialog: false,
      initialCalc: undefined,
      dialog: false,
      isCopyingData: false,
      yearRange: {
        from: new Date().getFullYear(),
        to: new Date().getFullYear() + 1,
      },
      filter: {
        name: "",
        types: [],
        membershipTypes: [],
        year: new Date().getFullYear().toString(),
        showDeactivated: false,
        showOnlyMissingRows: false,
      },
      sort: {
        key: "year",
        direction: "asc",
      },
    };
  },
  computed: {
    ...mapGetters([Getters.ASSOCIATIONS, Getters.CALCULATIONS]),
    orderedCalculations(): Array<any> {
      const filteredCalculations = filterCalculations(
        this.calculations,
        this.filter,
        this.associations
      );
      const withNames = filteredCalculations.map((calc: Calculation) => ({
        ...calc,
        associationName: this.getOrganizationName(calc.nhoNumber),
      }));

      return sortByKey(withNames, this.sort);
    },
    getMissingRowsLabel(): string {
      return `Vis kalkulasjoner som mangler i ${this.filter.year}`;
    },
    isLoading(): boolean {
      return (
        this.associations === undefined || this.calculations === undefined
      );
    },
    getCalculationTypes(): Array<{ key: string; display: string }> {
      return calculationTypesItems;
    },
    getMembershipTypes(): Array<{ key: number; display: string }> {
      return membershipTypeItems;
    },
  },
  watch: {
    createCalcDialog(val) {
      if (val === false) {
        this.initialCalc = undefined;
      }
    },
  },
  created() {
    this.fetchCalculations();
  },
  methods: {
    ...mapActions([Actions.FETCH_CALCULATIONS]),
    ...mapMutations([Mutations.SET_OPEN_CALCULATION]),
    getCalculationTypeLabel(type: string): string {
      return type === "Contingent" ? "Kontingent" : "Serviceavgift";
    },
    getMembershipTypeLabel(type: number): string {
      return type === 0
        ? "Ordinært Medlemskap"
        : type === 1
        ? "Fagmedlemskap"
        : "Ekstraordinært Medlemskap";
    },
    activateDialog(calculation: Calculation): void {
      this.createCalcDialog = true;
      this.initialCalc = calculation;
    },
    copyCalculations(): void {
      this.isCopyingData = true;
      this.$store
        .dispatch(Actions.COPY_CALCULATIONS, this.yearRange)
        .then((message) => {
          this.$toast.success(message);
          this.dialog = false;
          this.isCopyingData = false;
        })
        .catch((message) => {
          this.$toast.error(message);
          this.dialog = false;
          this.isCopyingData = false;
        });
    },
    openCalculation(calculation: Calculation, event: any) {
      if (event.ctrlKey == true) {
        window.open(
          `calculation?org=${calculation.nhoNumber}&type=${calculation.calculationType}&year=${calculation.year}&membershiptype=${calculation.membershipType}`
        );
      } else {
        this.setOpenCalculation(calculation);
        this.$router.push({
          name: "Calculation",
          query: {
            org: calculation.nhoNumber.toString(),
            type: calculation.calculationType.toString(),
            year: calculation.year.toString(),
            membershipType: calculation.membershipType.toString(),
          },
        });
      }
    },
    getCalculationType(ct: number) {
      return calculationTypes[ct];
    },
    getOrganizationName(number: number): string {
      return (
        this.associations.find((x: Federation) => x.nhoNumber == number)
          ?.name || number.toString()
      );
    },
    setSort(sort: Sort): void {
      this.sort = sort;
    },
  },
});
